import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  selectedConversation: any;
  selectedUserMessages: any;
  loading: boolean;
  error: SerializedError | null;
} = {
  selectedConversation: null,
  selectedUserMessages: null,
  loading: false,
  error: null,
};

export const fetchSelectedUserMessages = createAsyncThunk(
  'selectedConversation/fetchSelectedUserMessages',
  async ({ activityId, receiverId }: { activityId: string; receiverId: string }) => {
    const accessTokenJSON = localStorage.getItem('auth');
    const data1 = JSON.stringify({
      query: `query User_messages($receiverId: String!, $activityId: String!) {
  user_messages(receiverId: $receiverId, activityId: $activityId) {
    count
    data {
      _id
      sender {
        _id
        displayName
        displayImageUrl
        description
        role
      }
      receiver {
        _id
        displayName
        displayImageUrl
        description
        role
      }
      activity {
        _id
      }
      content
      attachments
      senderHasSend
      receiverHasReceived
      receiverHasRead
      createdAt
      updatedAt
    }
  }
}`,
      variables: {
        activityId,
        receiverId,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = await axios(config);
    return response.data;
  }
);

const selectedConversationSlice = createSlice({
  name: 'selectedConversation',
  initialState,
  reducers: {
    setSelectedConversation: (state, action) => {
      state.selectedConversation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSelectedUserMessages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSelectedUserMessages.fulfilled, (state, action) => {
      state.loading = false;
      state.selectedUserMessages = action.payload.data.user_messages;
      state.error = null;
    });
    builder.addCase(fetchSelectedUserMessages.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error ?? null;
    });
  },
});

export const { setSelectedConversation } = selectedConversationSlice.actions;
export default selectedConversationSlice.reducer;
